@if ((showTotals$ | async) !== true) {
  <app-gbm-overview></app-gbm-overview>
}
@if ((showTotals$ | async) === true) {
  <app-gbm-totals></app-gbm-totals>
}
